import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AddGoalDialogComponent } from './add-goal-dialog/add-goal-dialog.component';
import { AuthService } from 'src/app/core/services/auth.service';
import { DatePipe } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';


@Component({
    selector: 'app-care-plan',
    templateUrl: './care-plan.component.html',
    styleUrls: ['./care-plan.component.css'],
    standalone: false
})
export class CarePlanComponent {
  careplan:any;
  careplanid:any;
  goals:any[]=[];
  constructor(
    private dialog: MatDialog,
    private auth:AuthService,
    private datepipe:DatePipe,
    private route:ActivatedRoute,
    private router: Router
  ) {}


  nutrition:any[]=[];
  fabopen = false;
  today = new Date();
  dietRequired:any[]=[];
  dietReadings:any[]=[]
  allDietReadings:any[]=[]

  ngOnInit(){

    this.route.paramMap.subscribe((params:any) => {
      this.careplanid = params.get('id') || '';
      
    });

    // this.getMedicalConditions();
    this.getGoals(this.careplanid);
    this.getDiet(this.careplanid);
    this.getTodayReading()
    this.getDietRequired();
  }

  toggleFab(){
    this.fabopen = !this.fabopen
  }
openAddGoalDialog() {
  const dlg = this.dialog.open(AddNutritionDialogComponent, { 
    width: '500px',
    height: '500px',
    data: {
      mode:'add',
      details:this.nutrition,
      readings: this.allDietReadings
    } });

  dlg.afterClosed().subscribe(res => {
    if (res) {
      
      this.getDiet(this.careplanid);
      this.getDietRequired();
      this.getTodayReading()
      // handle updated data
    }
    
  });
}
openEditGoalDialog() {
  this.dialog.open(AddGoalDialogComponent, {
    width: '500px',
    height: '500px',
    data: {
      mode:'add',
      details:this.nutrition
    }
  }).afterClosed().subscribe(result => {
    if (result) {
     
      // handle updated data
    }
  });
}

  goBack(): void {
    this.router.navigate(["/health/dashbord"])
  }

 getCategories()
 {
  this.auth.get_category_all().subscribe((res:any)=>{
    if(res){
     
    }
  })
 }
 getCarePlan(){
    this.auth.get_care_plan().subscribe((res:any) =>{
      this.careplan= res.data.careplan.length;
      this.careplanid = res.data.careplan[0].id;
    })
  }

  getGoals(id:any){
    this.auth.get_careplangoal(id).subscribe((res:any)=>{
      if(res.error==false){
        this.goals = res.data.goal
       
      }
    })
  }
  isNumeric(value: any): boolean {
  return !isNaN(parseFloat(value)) && isFinite(value);
}


  getMedicalConditions(){
    this.auth.profile_details_cat('medicalcondition').subscribe((res:any)=>{
      if(res){
    
      }
    })
  }

  getDietRequired(){
    let data = this.datepipe.transform(this.today,'YYYYMMdd')
    this.auth.get_diet_graph(data).subscribe((res:any)=>{
      if(res){
      //  this.dietRequired = res.data.dietreadings
      }

    })
  }

  getTodayReading(){

     let data = this.datepipe.transform(this.today,'YYYYMMdd')
    //  this.auth.get_diet_reading(data).subscribe((res:any)=>{
    //   if(res.error==false){
    //     this.dietReadings = res.data.dietreading.slice(0, 6).map((n: any) => ({
    //       title: n.name,      
    //       qty: n.value,       
    //       unit: n.valueUnit       
    //     }));
    //     console.log(res)
    //   }
    //  })
    this.auth.get_diet_reading(data).subscribe((res: any) => {
  if (!res.error) {
    const readings = res.data.dietreading; // use all readings

    const combined: { [key: string]: { title: string, qty: number, unit: string} } = {};

    readings.forEach((n: any) => {
       const name = n.name.toLowerCase();
      if (combined[name]) {
        // add value if name already exists
        combined[name].qty += parseFloat(n.value);
      } else {
        // initialize
        combined[name] = {
          title: name,
          qty: parseFloat(n.value),
          unit: n.valueUnit
        };
      }
    });
    this.allDietReadings = res.data.dietreading;
    // convert object to array
    this.dietReadings = Object.values(combined);
  }
});


  }

  // getProgress(item: any): number {
  //   console.log(item);
  //   console.log(this.dietRequired);

  //   if (!item || !this.dietRequired) return 0;

  //   const matched = this.dietRequired.find(req => req.name === item.title);

  //   const required = matched ? parseFloat(matched.value) : 0; // already achieved
  //   const achieved = parseFloat(item.qty); // target/total

  //   if (!achieved || isNaN(achieved)) return 0;

  //   const progress = ((achieved - required) / achieved) * 100; // how much is left achieved

  //   return Math.min(Math.max(progress, 0), 100); // clamp between 0–100
  // }

  getDietQuantity(item: any): any{
    const diet = this.dietReadings.find(req => req.title.toLowerCase() === item.title.toLowerCase());
    return diet?.qty ? Math.floor(diet.qty) : "";
  }

  getProgress(item: any): number {
   

    if (!item || !this.dietRequired) return 0;
    item = this.dietReadings.find(req => req.title.toLowerCase() === item.title.toLowerCase());
    if (!item) return 0;

    const matched = this.dietRequired.find(req => req.title.toLowerCase() === item.title.toLowerCase());
    const required = matched ? parseFloat(matched.qty) : 0; // already achieved
    const achieved = parseFloat(item.qty); // target/total

    if (!achieved || isNaN(achieved)) return 0;

    const progress = (achieved / required) * 100;
    return Math.floor(Math.min(Math.max(progress, 0), 100));
  }

  normalizeWord(word: string): string {
    const lowerWord = word.toLowerCase().trim();
    
    // Handle common pluralizations
    if (lowerWord.endsWith('s') && lowerWord !== 's') {
        return lowerWord.slice(0, -1); // Remove trailing 's'
    }
    return lowerWord;
  };

  getCardClass(item: any): string {
    
    const title = this.normalizeWord(item.title)
    switch (title) {
      case 'protein': return 'card-protein';
      case 'carb': return 'card-carbs';
      case 'fat': return 'card-fat';
      case 'calorie': return 'card-calorie';
      case 'sugar': return 'card-sugar';
      case 'sodium': return 'card-sodium';
      default: return 'card-protein'
      
    }
  }


getProgressClass(item:any): string {
  // const classes = ['progress-orange', 'progress-yellow', 'progress-green', 'progress-red', 'progress-blue', 'progress-purple'];
  // return classes[index % classes.length];
   const progress = this.getProgress(item);

  if (progress >= 90) return 'progress-green';
  else if (progress >= 70) return 'progress-blue';
  else if (progress >= 50) return 'progress-yellow';
  else return 'progress-red';
}
  getDiet(id:any){
    this.auth.get_careplandiet(id).subscribe((res:any)=>{
      if(res){
         this.nutrition = res.data.diet
         this.dietRequired = res.data.diet
         
      }
    })
  }

  // getExercise(){
  //   this.auth.get_careplabexerice(this.careplanid).subscribe((res:any)=>{
  //     if(res){
  //       console.log(res)
  //     }
  //   })

  }

  






@Component({
    templateUrl: './add-calories-dialog.html',
    styleUrls: ['./care-plan.component.css'],
    standalone: false
})
export class AddNutritionDialogComponent {

  nutritionForm: any;
  mode: 'add' | 'edit' = 'add';
  selectedMeal: string = 'breakfast';

  nutrientData:any[]=[];
  dietReadings:any[]=[];
  tag_list:any;
  tag_id = 4;
  today = new Date()

  mealTypes = [
    { label: 'Breakfast', key: 'breakfast', icon: 'assets/images/health/homeimg/exandcareplan/breakfast.png' },
    { label: 'Lunch', key: 'lunch', icon: 'assets/images/health/homeimg/exandcareplan/lunch.png' },
    { label: 'Dinner', key: 'dinner', icon: 'assets/images/health/homeimg/exandcareplan/dinner.png' },
    { label: 'Snack', key: 'snack', icon: 'assets/images/health/homeimg/exandcareplan/break.png' }
  ];

  constructor(
    private fb: FormBuilder,
    private auth:AuthService,
    public datepipe:DatePipe,
     private toastr: ToastrService,
    private dialogRef: MatDialogRef<AddNutritionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.mode = data?.mode === 'edit' ? 'edit' : 'add';
      this.nutrientData = data?.details
      this.dietReadings = data?.readings
 


  }

  

  ngOnInit(): void {
    
     this.getTags();
      this.nutritionForm = this.fb.group({
      nutrients: this.fb.array([]),
      date: new Date(),
      time: this.getCurrentTime()
    });

    this.populateNutrients();
   
  }

   get nutrients(): FormArray {
    return this.nutritionForm.get('nutrients') as FormArray;
  }

    populateNutrients(tag: number = 4) {
    this.nutrientData.forEach(n => {
      this.nutrients.push(this.fb.group({
        name: n.title,
        value: 0,
        valueUnit: n.unit,
        qty:n.qty,
        tag: 4,
        sequence: 1,
        readingDateTime: ''
      }));
    });
    // this.nutrients.clear();   // ← IMPORTANT: removes old items
    // this.nutrientData.forEach(n => {
    //   const matched = this.dietReadings.find(
    //     r => r.name.toLowerCase() === n.title.toLowerCase() &&
    //   (tag ? r.tag?.id === tag : true)   // match by tag ONLY if tag is passed
    //   );

    //   this.nutrients.push(
    //     this.fb.group({
    //       name: n.title,
    //       value: matched ? parseInt(matched.value) : 0,
    //       valueUnit: matched ? matched.valueUnit : n.unit,
    //       qty: matched ? matched.qty : n.qty,
    //       tag: matched ? matched.tag : 4,
    //       sequence: 1,
    //       readingDateTime: matched ? new Date() : ''
    //     })
    //   );
    // });
  }

   
    selectMeal(meal: any) {
    this.selectedMeal = meal.key;
    this.tag_id = meal.id;
    // this.populateNutrients(meal.id)
   
  }
  

  getTags() {
  this.auth.get_category("NUTRITION").subscribe((res: any) => {
    if (res) {
      const id = res.data.nutrition[0].id;
      this.auth.get_tag_list(id).subscribe((res: any) => {
        if (res) {
          this.tag_list = res.data.tag;

          this.mealTypes = this.tag_list.map((tag: any) => {
            const key = tag.description.toLowerCase(); // e.g., "Breakfast" -> "breakfast"
            const iconMap: any = {
              breakfast: 'assets/images/health/homeimg/exandcareplan/breakfast.png',
              lunch: 'assets/images/health/homeimg/exandcareplan/lunch.png',
              dinner: 'assets/images/health/homeimg/exandcareplan/dinner.png',
              snack: 'assets/images/health/homeimg/exandcareplan/break.png',
            };

            return {
              id: tag.id,
              label: tag.description,
              key: key,
              icon: iconMap[key] || '', // fallback to empty icon if not found
            };
          });
        }
      });
    }
  });
}
 getCurrentTime(): string {
    const now = new Date();
    return now.toTimeString().slice(0, 5); // "HH:mm"
  }
 formatDateTime(date: Date, time: string): string {
    const dateStr = new Date(date).toLocaleDateString('en-GB');
    const [h, m] = time.split(':');
    const d = new Date();
    d.setHours(+h, +m);
    const timeStr = d.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' });
    return `${dateStr} ${timeStr}`;
  }
  

  onSave(): void {
    const formValue = this.nutritionForm.value;
    const date = this.datepipe.transform(formValue.date, 'MM-dd-yyyy');
    const time = this.datepipe.transform(`1970-01-01T${formValue.time}`, 'hh:mm a');        
    const datetime = `${date} ${time}`;
   

    // const updatedNutrients = formValue.nutrients.map((n: any) => {
    //   // Find corresponding dietReading by name/title
    //   const diet = this.dietReadings.find((d: any) => d.title === n.name);
      
    //   // If value is 0 and diet exists, replace with diet value
    //   if (n.value === 0 && diet) {
    //     return { ...n, value: diet.qty }; // or diet.value if appropriate
    //   }
    //   return n;
    // });

    // // Update the formValue nutrients
    // formValue.nutrients = updatedNutrients;

    // Create a fast lookup map for readings
    const readingMap = new Map(
      this.dietReadings
        .filter(r => r.tag.id === this.tag_id)
        .map(r => [r.name, parseInt(r.value)])
    );

    const check_value_entered = formValue.nutrients.filter((n: any) => n.value && n.value > 0)

    if (check_value_entered.length === 0){
      this.toastr.error("please provide atleast one value")
      return
    }

    // Update nutrient values (if 0 and reading exists)
    const updatedNutrients = formValue.nutrients.map((n: any)=> ({
      ...n,
      value: n.value === 0 && readingMap.has(n.name)
        ? readingMap.get(n.name)
        : n.value
    }));

    const output = updatedNutrients
    .filter((n: any) => n.value && n.value > 0)
    .map((n: any) => ({
       name: n.name,
      value: n.value,
      valueUnit: n.valueUnit,
      readingDateTime: datetime,
      tag: this.tag_id,//this.tag_id, //default for now, future enhancement
      sequence: 1,
    }));

  
    this.auth.add_diet_reading(output).subscribe((res:any)=>{
      if(res){
        this.toastr.success("Added Diet Reading Succesfully!!")
        this.dialogRef.close('added');
      }

    })
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}


